import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { MEMBERSHIP_API } from 'modules/school/api/membership-api'
import type { CourseLectureId } from '../types/course-lecture-interface'

interface UseCompleteCourseLectureResult {
  completeCourseLecture: (courseLectureId: number) => Promise<void>
  isFetching: boolean
}

export const useCompleteCourseLecture = (): UseCompleteCourseLectureResult => {
  const { fetcher, isFetching } = useApiWrapperWithErrorValidation({
    method: RequestMethodsEnum.post,
  })
  return {
    completeCourseLecture: async (courseLectureId: CourseLectureId) => {
      await fetcher(`${MEMBERSHIP_API}/lecture/${courseLectureId}/complete`)
    },
    isFetching: isFetching,
  }
}
